import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { MobileMenu, MobileMenuButton } from './MobileMenu';
export interface NavbarProps {
  'data-id'?: string;
}
export const Navbar: React.FC<NavbarProps> = ({
  'data-id': dataId
}) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navLinks = [{
    href: '#features',
    label: 'Features'
  }, {
    href: '#how-it-works',
    label: 'How It Works'
  }, {
    href: '#pricing',
    label: 'Pricing'
  }, {
    href: '#faq',
    label: 'FAQ'
  }];
  return <>
      <nav className="sticky top-0 z-50 w-full bg-[#121212] border-b border-white/10" style={{
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
    }} data-id="element-2036">
        <div className="max-w-[1240px] mx-auto px-6 md:px-8 py-4 md:py-5 flex items-center justify-between gap-4 md:gap-10" data-id="element-2037">
          {/* Logo Section */}
          <div className="flex-shrink-0" data-id="element-2038">
            <a href="/" className="flex items-center gap-2 no-underline focus:outline-none rounded-xl transition-all duration-300 p-1.5 hover:scale-105" aria-label="AcquireFlow Home" data-id="element-2039">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dxuXv5AoswiCCU7F4ucVPA/AcquireFlow_Logo_%287%29.svg" alt="AcquireFlow" className="h-[40px] md:h-[48px] w-auto" data-id="element-2040" />
            </a>
          </div>

          {/* Desktop Navigation Links */}
          <nav className="hidden md:flex items-center justify-center gap-2" aria-label="Main navigation" data-id="element-2041">
            {navLinks.map(link => <a key={link.href} href={link.href} className="relative px-4 lg:px-5 py-3 text-[14px] lg:text-[15px] font-bold no-underline group focus:outline-none focus:ring-2 focus:ring-[#3ab795] focus:ring-offset-2 focus:ring-offset-[#121212] rounded-xl transition-all duration-200" style={{
            letterSpacing: '-0.3px',
            color: '#b8bcc8'
          }} onMouseEnter={e => {
            e.currentTarget.style.color = '#3ab795';
          }} onMouseLeave={e => {
            e.currentTarget.style.color = '#b8bcc8';
          }} data-id="element-2042">
                {link.label}
                <span className="absolute bottom-2 left-4 lg:left-5 right-4 lg:right-5 h-[3px] bg-gradient-to-r from-[#3ab795] via-[#3ab795] to-[#3ab795] rounded-full transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-out shadow-lg shadow-[#3ab795]/50" data-id="element-2043"></span>
              </a>)}
          </nav>

          {/* Desktop CTA Buttons */}
          <div className="hidden md:flex flex-shrink-0 items-center gap-3" data-id="element-2044">
            <a href="/login" className="flex items-center justify-center px-4 lg:px-6 py-2 lg:py-3 rounded-xl font-bold text-[14px] lg:text-[15px] transition-all duration-200 no-underline border-2 border-transparent hover:border-white/10 hover:bg-white/5 focus:outline-none focus:ring-2 focus:ring-[#3ab795] focus:ring-offset-2 focus:ring-offset-[#121212]" style={{
            letterSpacing: '-0.3px',
            color: '#b8bcc8'
          }} aria-label="Log in to your account" data-id="element-2045">
              Log In
            </a>
            <a href="/trial" className="group relative flex items-center justify-center gap-2 px-6 lg:px-8 py-2.5 lg:py-3 rounded-xl font-bold text-[14px] lg:text-[15px] text-white transition-all duration-300 no-underline focus:outline-none focus:ring-2 focus:ring-[#3ab795] focus:ring-offset-2 focus:ring-offset-[#121212] hover:scale-105 active:scale-100 shadow-[0_4px_16px_rgba(58,183,149,0.3)] hover:shadow-[0_8px_24px_rgba(58,183,149,0.4)]" style={{
            backgroundColor: '#3ab795',
            letterSpacing: '-0.3px'
          }} onMouseEnter={e => {
            e.currentTarget.style.backgroundColor = '#2d9f7e';
          }} onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = '#3ab795';
          }} aria-label="Join our beta program" data-id="element-2046">
              <span className="relative z-10" data-id="element-2047">Join Beta</span>
              <ArrowRight className="w-4 h-4 lg:w-5 lg:h-5 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={2.5} data-id="element-2048" />
            </a>
          </div>

          {/* Mobile Menu Button */}
          <MobileMenuButton onClick={() => setIsMobileMenuOpen(true)} isOpen={isMobileMenuOpen} data-id="element-2049" />
        </div>
      </nav>

      {/* Mobile Menu */}
      <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} links={navLinks} data-id="element-2050" />
    </>;
};